module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_PDF-Download_black-605c9fc763defdab57230e333197d0b8.svg";